<template>
  <v-dialog
  v-model="visible"
  max-width="500px"
  persistent
  >
    <v-card>
      <v-card-title
        class="headline font-weight-medium white--text"
        style="background-color: #0b4f6a; font-size: 20px;"
      >
        ATENÇÃO
      </v-card-title>
      <v-card-text class="text-xs-center py-4">
        <div style="color: rgba(0, 0, 0, 0.7); font-size: 16px;">
          Para exclusão do item, além dessa ação, será necessário aguardar a confirmação do analista referente a este Endosso.
        </div>
      </v-card-text>
    
      <v-card-actions class="justify-end pb-4 actions">
        <v-btn
          class="button-permanecer"
          flat
          @click="onClose"
        >
          OK, ENTENDI
        </v-btn>
      </v-card-actions>
    
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalAvisoExclusaoCorretor',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    onClose() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.v-dialog__content {
  align-items: center;
}

.btn-permanecer {
  background-color: #0b4f6a;
  color: white;
  text-transform: uppercase;
  font-weight: 600;
  min-width: 160px;
}
.actions {
    padding-right: 2rem;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/corretor-reserva/ModalAvisoExclusaoCorretor.vue